import { isAdminSite } from '~/utils';
import useLearnerHeaderOffset from './useLearnerHeaderOffset';
import useAdminHeaderOffset from './useAdminHeaderOffset';

export default function useHeaderOffset() {
  const learnerHeaderOffset = useLearnerHeaderOffset();
  const adminHeaderOffset = useAdminHeaderOffset();
  return isAdminSite() ? adminHeaderOffset : learnerHeaderOffset;
}
